<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="dialog-reward dialog-wrap">
    <div
      class="dialog-reward__box dialog-box__animation dialog-content__box"
      @click="handleClick"
    >
      <slot name="title">
      </slot>

      <div class="dialog-box__body">
        <div
          v-if="lang.topDesc"
          class="dialog-box__top-desc"
          v-html="DOMPurify.sanitize(lang.topDesc,{ADD_ATTR: ['target']})"
        >
        </div>
        <div
          v-if="content.length"
          class="reward-list"
        >
          <template v-for="(item,index) in content">
            <RewardTooltip
              v-if="item.tooltip"
              :key="`tooltip-${index}`"
              :item="item"
              :items="Array.isArray(item.tooltip) ? item.tooltip : []"
              :num-position="numPosition"
              v-bind="getTooltipProps(item)"
            />
            <RewardItem
              v-else
              :key="`reward-${index}`"
              :item="item"
              :num-position="numPosition"
            />
          </template>
        </div>
        <div
          v-if="lang.bottomDesc"
          class="dialog-box__bottom-desc"
          v-html="DOMPurify.sanitize(lang.bottomDesc,{ADD_ATTR: ['target']})"
        >
        </div>
      </div>
      <slot name="footer"></slot>
      <slot name="close">
      </slot>
    </div>
  </div>
</template>
<script>
import DOMPurify from 'dompurify'
import RewardItem from './RewardItem.vue'
import RewardTooltip from './Tooltip.vue'
export default {
  name: 'RewardContent',
  components: {
    RewardItem,
    RewardTooltip,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    lang: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Array,
      default: () => ([]),
    },
    numPosition: {
      type: String,
      default: 'bottom-end',
    },
    contentStopPropagation: {
      type: Boolean,
      default: true,
    },
    // amtPosition: {
    //   type: String,
    //   default: 'bottom',
    // },
    // numPosition值解释：
    // top           # 顶部中间位置
    // top-start     # 顶部左侧位置
    // top-end       # 顶部右侧位置
    // left          # 左侧中间位置
    // left-start    # 左侧上方位置
    // left-end      # 左侧下方位置
    // right         # 右侧中间位置
    // right-start   # 右侧上方位置
    // right-end     # 右侧下方位置
    // bottom        # 底部中间位置
    // bottom-start  # 底部左侧位置
    // bottom-end    # 底部右侧位置
  },
  data() {
    return {
      DOMPurify,
    }
  },
  methods: {
    getTooltipProps(item) {
      // 数组用于 Tooltip 内部列表，只有对象配置才作为 Tooltip props 透传。
      return item.tooltip && !Array.isArray(item.tooltip) ? item.tooltip : {}
    },
    handleClick(event) {
      if (this.contentStopPropagation) {
        event.stopPropagation()
      }
    },
  },
}

</script>
